import { render } from "./ModalPrintTransfer.vue?vue&type=template&id=29ffbaca&scoped=true"
import script from "./ModalPrintTransfer.vue?vue&type=script&lang=js"
export * from "./ModalPrintTransfer.vue?vue&type=script&lang=js"

import "./ModalPrintTransfer.vue?vue&type=style&index=0&id=29ffbaca&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ffbaca"]])

export default __exports__